import React, { FC, useContext, useEffect, useState } from "react";
import Button from "../../components/UI/button/GgButton";
import ImageLoader from "../../components/imageLoader/ImageLoader";
import Input from "../../components/UI/input/GgInput";
import JoditEditor from "jodit-react";
import CustomSelect from "../../components/UI/customSelect/CustomSelect";
import { useSelect } from "../../customHooks/useSelect";
import { INews } from "../../models/INews";
import { setTags } from "../../utils";
import { Context } from "../..";
import { Editor } from "../../components/UI/editor/QuillEditor";

interface INewsForm {
  data?: INews;
  onClose: () => void;
  page?: number;
  actionData?: any;
}

interface IListItem {
  value: boolean;
  label: string;
  default?: boolean;
}

const NewsForm: FC<INewsForm> = ({ data, onClose, page, actionData }) => {
  const { news } = useContext(Context);
  const [formData, setFormData] = useState<INews>(data as INews);
  const [bannerImage, setBannerImage] = useState<string>("");
  const [tags, setNewTags] = useState("");
  const positionSelect = useSelect();
  const statusSelect = useSelect();

  useEffect(() => {
    if (data !== undefined) {
      setFormData(data);
      setNewTags(data.tags.join(", "));
    }
  }, []);

  useEffect(() => {
    setFormData({ ...formData, position: positionSelect.selected?.value });
    setFormData({ ...formData, status: statusSelect.selected?.value });
  }, [positionSelect.selected, statusSelect.selected]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const formatted = { ...formData, tags: setTags(tags), banner: false };

    if (!bannerImage) {
      return alert("Please, add image");
    }

    if (data === undefined) {
      news
        .createOne({ ...formatted, created_at: new Date(),mainImage: bannerImage }, page)
        .then()
        .catch(console.log);
    } else {
      news
        .updateOne(
          { ...formatted, updated_at: new Date(), mainImage: bannerImage },
          page
        )
        .catch(console.log);
    }

    onClose();
  }

  function resetForm() {
    setFormData({} as INews);
  }

  console.log("formadata",formData)
  return (
    <form className="news-modal" onSubmit={handleSubmit}>
      <ImageLoader
        label="Add image"
        value={formData?.mainImage}
        onChange={(img) => {
          setBannerImage(img);
          console.log(
            "img - это уже картинка в base64 или при  параметре multi=true массив картинок в формате base64"
          );
        }}
      />
      <Input
        type="text"
        label="Add a title"
        id="post-title"
        value={formData?.name || ""}
        placeholder="Title"
        required={true}
        onChange={(value) => setFormData({ ...formData, name: value })}
      />
      <div className="add-desc">
        <div className="label">Add description</div>
        <Editor
          value={formData?.content}
          onChange={(value) => setFormData({ ...formData, content: value })}
          placeholder="Enter content"
          style={{
            height: "16rem",
            marginBottom: "1rem",
          }}
          readOnly={actionData?.add || actionData?.edit}
        />
      </div>
      <Input
        type="text"
        label="Add a tag"
        id="post-tag"
        value={tags}
        placeholder="Tag"
        onChange={(value) => setNewTags(value)}
      />
      <div className="input-row">
        <div className="select-group">
          <CustomSelect
            selected={formData?.status ? formData?.status : "show"}
            defaultValue="Active"
            list={[
              { value: "show", label: "Actite", default: true },
              { value: "hidden", label: "Archive" },
            ]}
            onChange={statusSelect.handleSelect}
          />
          {/* <CustomSelect
            selected={formData?.position ? formData?.position : "show"}
            defaultValue="Active"
            list={[
              { value: "show", label: "Actite", default: true },
              { value: "hidden", label: "Archive" },
            ]}
            disabled={true}
            onChange={positionSelect.handleSelect}
          />
           */}
        </div>
        <div className="btn-group">
          <Button
            label="Reset"
            type="reset"
            stylesType="border"
            onPress={resetForm}
          />
          <Button label="Save" type="submit" />
        </div>
      </div>
    </form>
  );
};

export default NewsForm;
